import React from 'react';

function NotFoundPage() {
  return <div>페이지를 찾을 수 없습니다</div>;
}

export default NotFoundPage;
